export default __webpack_public_path__ + "static/media/ORM.d507a3db.png";